var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ui-stars"},_vm._l((5),function(number){return _c('span',{key:number,class:['iconfont icon-star', number <= _vm.starNum ? 'active' : ''],style:({ fontSize: _vm.size + 'px' })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }